import styled from 'styled-components';

interface IProps {
	background_color: string
}

export const EventCardQuestionNumber = styled.div<IProps>`
	height: 80px;
	width: 80px;
	border-radius: 30px;
	background-color: ${props => props.background_color};
	color: #fff;
	display: flex;
	align-content: center;
	justify-content: center;
	flex-direction: column;
	p {
		text-align: center;
		font-size: 8px;
		line-height: 10px;
		strong {
			font-family: ${ ( { theme } ) => theme.fonts.bold };
			font-size: 30px;
			font-weight: bold;
			line-height: 30px;
			text-align: center;
		}
	}
`;
